const slotTitle = {
  AVAILABLE: 'Available',
  FUTURE: 'Future',
  LOCK: 'Lock',
  FULL: 'Full',
  PROV: 'Prov',
};

const slotColor = {
  BLUE: 'blue',
  RED: 'red',
  ORANGE: 'orange',
  GREY: 'grey',
};

export const getStatusData = slotData => {
  const statusData = {};
  const { is_locked: isLocked, status } = slotData || {};

  switch (status) {
    case 'ACT':
      statusData.title = slotTitle.AVAILABLE;
      statusData.color = slotColor.BLUE;
      break;
    case 'FTR':
      statusData.title = slotTitle.FUTURE;
      statusData.color = slotColor.BLUE;
      break;
    case 'FULL':
      statusData.title = slotTitle.FULL;
      statusData.color = slotColor.RED;
      break;
    case 'PROV':
      statusData.title = slotTitle.AVAILABLE;
      statusData.color = slotColor.GREY;
      break;
    default:
      break;
  }

  if (isLocked) {
    statusData.title = slotTitle.LOCK;
    statusData.color = slotColor.ORANGE;
  }

  return statusData;
};
